module.exports = __webpack_public_path__ + "i18n/translation-fr.7505f702.json";